import template from './OnboardingChecklistStep.html';
import './OnboardingChecklistStep.scss';
export class OnboardingChecklistStepController {
}
export const OnboardingChecklistStepComponent = {
    controller: OnboardingChecklistStepController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        heading: '@?',
        description: '@?',
        isLoading: '<?',
        checked: '<?',
        isNew: '<?',
    },
};
